module.exports = __webpack_public_path__ + "static/media/scalpel.7c20ebf3.svg";